import { Injectable } from '@angular/core';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { UtilidadesCrudService } from '@appNeo/neoShared/services/utilidades/utilidades-crud.service';
import { HttpClient } from '@node_modules/@angular/common/http';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';
import { TiposTurnosColorEnum } from '@appNeo/core/global';

@Injectable({
  providedIn: 'root'
})
export class IvasService extends UtilidadesCrudService {

  constructor(
    http: HttpClient,
    public auxiliar: AuxiliarService,
  ) {
    super(
      http,
      auxiliar,
      'ivas',
      'ivas',
      'IVA',
      'IVA',
      [
      ]
    );
  }

  mapearEntidad(entidad: any): any {
    entidad['nombre'] = entidad.nombreModalidad.concat( ' (' + entidad.valor + '%' + ')');
    return entidad;
  }
  /************************************ 
  * Funciones apoyo                  *
  *************************************/
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let peticion = {};
    const id = route.params?.id;   
    if (id) {
      peticion['entidad'] = this.get(id).pipe(
        catchError(err => of(null))
      )
    }
    if (Object.keys(peticion).length > 0) {
      return forkJoin(peticion);
    } else {
      of(true);
    }
  }

}


